/**
 * @file    GitRev.css
 * @author  Liang Wang liang@distributive.network
 * @date    August, 2023
 *
 * Force the text to shrink to something tiny and until someone hovers on it. Then we expand upon the size needed
 */

.gitHash {
    width: 0.5em;
    height: 0.5em;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
}
.gitHash:hover {
    width: initial;
    height: initial;
    overflow: initial;
}
